import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import AuthContext from "../context/AuthContext";

const Dashboard = () => {
  const [data, setData] = useState({});
  const { user } = useContext(AuthContext);
  const getData = async () => {
    const { status, data: response_users } = await apiGet(apiPath.getDashboard);
    if (status === 200) {
      if (response_users.success) {
        setData(response_users?.results);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <section className="main-inner-outer py-3">
        <Container fluid>
          <Row>
            <Col lg={3} sm={3} className="mb-lg-0 mb-1">
              <div
                style={{
                  background: "white",
                  border: "1px solid grey",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                <h2>{data?.totalUser || 0}</h2>
                <p style={{ fontSize: "18px", padding: "0", margin: "0" }}>
                  Total User
                </p>
              </div>
            </Col>
            {user?.userType !== "agent" && (
              <Col lg={3} sm={3} className="mb-lg-0 mb-1">
                <div
                  style={{
                    background: "white",
                    border: "1px solid grey",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                >
                  <h2>{data?.totalAgent || 0}</h2>
                  <p style={{ fontSize: "18px", padding: "0", margin: "0" }}>
                    Total Agent
                  </p>
                </div>
              </Col>
            )}
            <Col lg={3} sm={3} className="mb-lg-0 mb-1">
              <div
                style={{
                  background: "white",
                  border: "1px solid grey",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                <h2>{data?.activeUser || 0}</h2>
                <p style={{ fontSize: "18px", padding: "0", margin: "0" }}>
                  Total Online User
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Dashboard;
